var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("table", [
    _c("caption", [_vm._v("Consignment Item Summary")]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("tbody", [
      _c("tr", [
        _c("td", [_vm._v(_vm._s(_vm.noItems))]),
        _vm._v(" "),
        _c("td", [_vm._v(_vm._s(_vm.weight))]),
        _vm._v(" "),
        _c("td", [_vm._v(_vm._s(_vm.volume))]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Items")]),
        _vm._v(" "),
        _c("th", [_vm._v("Weight")]),
        _vm._v(" "),
        _c("th", [_vm._v("Volume")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }